module.exports = __webpack_public_path__ + "img/thumb_38.8ff7219d.jpg";